import {
  toRequestFormApplicantSelectOption,
  useCreateRequest,
} from '../../../../Request'
import { UserProfileTabId, useUserProfileContext } from '../../../../User'

import { getUserProfilePageRequestFormInitialValues } from './useUserProfilePageCreateServiceRequestAction.utils'

export function useUserProfilePageCreateServiceRequestAction() {
  const { handleEntityReload, handleReloadTabs, setModal, userData } =
    useUserProfileContext()

  function handleReload() {
    handleEntityReload()

    handleReloadTabs([UserProfileTabId.Requests])
  }

  const { handleOpenCreation } = useCreateRequest({
    setModal,
    onReload: handleReload,
  })

  function handleClickCreateServiceRequest() {
    handleOpenCreation({
      formProps: {
        initialValues: getUserProfilePageRequestFormInitialValues(userData),
      },
      wizardProps: {
        initialUser: toRequestFormApplicantSelectOption(userData),
      },
    })
  }

  return { handleClickCreateServiceRequest }
}
